/** Build module store URLs with return navigation. */

export function buildStoreUrl(slug, { module, returnTo, tab } = {}) {
  if (!slug) return '/';
  const params = new URLSearchParams();
  if (module) params.set('module', module);
  if (returnTo) params.set('returnTo', returnTo);
  if (tab) params.set('tab', tab);
  const qs = params.toString();
  return `/p/${encodeURIComponent(slug)}/store${qs ? `?${qs}` : ''}`;
}

export function encodeReturnTo(path) {
  if (!path) return '';
  try {
    return encodeURIComponent(path);
  } catch {
    return '';
  }
}

export function decodeReturnTo(raw) {
  if (!raw || typeof raw !== 'string') return null;
  try {
    const decoded = decodeURIComponent(raw);
    if (decoded.startsWith('/')) return decoded;
  } catch {
    // ignore
  }
  return null;
}

export function defaultReturnPath(slug, role) {
  if (!slug) return '/';
  if (role === 'superadmin' || role === 'admin') return `/p/${slug}/admin`;
  return `/p/${slug}/groups`;
}
